import { render, staticRenderFns } from "./editpos.vue?vue&type=template&id=fbf7131a"
import script from "./editpos.vue?vue&type=script&lang=js"
export * from "./editpos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports